import {
  GET_SERVICE_LIST_BY_TYPE,
  GetServiceType,
} from "@/graphql/queries/service-list";
import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

const useServiceList = (
  serviceType: GetServiceType = GetServiceType["COURSE_SERVICE"]
) => {
  const {
    data: serviceData,
    error,
    loading,
  } = useQuery(GET_SERVICE_LIST_BY_TYPE, {
    variables: {
      serviceType: serviceType,
    },
  });

  const data = useMemo(() => {
    if (serviceData) {
      return serviceData.servicesByType.map((item) => ({
        value: item.id,
        label: item.shortName,
      }));
    }
    return [];
  }, [serviceData]);

  return { error, loading, data };
};

export default useServiceList;
